import { default as ReactSelect } from "react-select";
import { useCallback, useState } from "react";

export const customSelectInputStyles = (theme) => {
    let borderColor;
    let bgColor;
    let color;
    let indicatorBgColor;
    let indicatorBorderColor;
    let indicatorFillColor;
    let shadow;
    let focusBorderColor;
    let hoverBorderColor;
    switch (theme) {
        case "reverse-contrast":
            borderColor = "#2b2b2b";
            focusBorderColor = "#c2beb9";
            hoverBorderColor = "#c5cad3";
            bgColor = "#1b1b1b";
            color = "#c1c1c1";
            indicatorBgColor = "#1b1b1b";
            indicatorBorderColor = "#2b2b2b";
            indicatorFillColor = "#c1c1c1";
            shadow = "rgba(62, 62, 65, 0.5)";
            break;
        default:
            borderColor = "#CED4DA";
            focusBorderColor = "#3d4146";
            hoverBorderColor = "#3a352c";
            bgColor = "#ffffff";
            color = "#3d4146";
            indicatorBgColor = "#f9f9fb";
            indicatorBorderColor = "#e4e7eb";
            indicatorFillColor = "#3d4146";
            shadow = "rgba(0, 0, 0, 0.15)";
            break;
    }
    return {
        control: (styles, state) => ({
            ...styles,
            boxShadow: 0,
            borderColor: state.isFocused ? focusBorderColor : borderColor,
            outline: state.isFocused? '2px solid #1256C1': 'none',
            backgroundColor: bgColor,
            cursor: "pointer",
            "&:hover": {
                borderColor: hoverBorderColor,
            },
        }),
        menu: (styles, state) => ({
            ...styles,
            boxShadow: "0px 2px 8px " + shadow,
        }),
        singleValue: (styles, state) => ({
            ...styles,
            color: color,
        }),
        indicatorSeparator: (styles, state) => ({
            ...styles,
            margin: 0,
            backgroundColor: "none",
        }),
        indicatorsContainer: (styles, state) => ({
            ...styles,
            backgroundColor: bgColor,
            height: "100%",
            cursor: "pointer",
            borderRadius: "4px",
        }),
    };
};

const Select = React.forwardRef((props, ref) => {
    const { Dyn, ...props2 } = props;
    const [isOpened, setIsOpened] = useState(false);

    const handleKeyDown = useCallback((e) => {
        // Open on enter key press
        if (e.key === "Enter" && !isOpened) {
            setIsOpened(true);
        }
        if (e.key === "Escape" && isOpened) {
            e.stopPropagation();
        }
    });
    return (
        <ReactSelect
            {...props2}
            ref={ref}
            styles={customSelectInputStyles(Dyn.preferences.getTheme())}
            onKeyDown={handleKeyDown}
            menuIsOpen={isOpened}
            onMenuOpen={() => {
                setIsOpened(true);
            }}
            onMenuClose={() => {
                setIsOpened(false);
            }}
        />
    );
});

export default Select;
